import {axiosIns} from 'config/api.config'
import {ENV} from 'config/ENV.config'

/**
 * In-app notifications live in portal-service (`public.notifications`), shared by every ErpBoi
 * product and scoped per row by module_key. Call them through the Portal gateway — same
 * arrangement as Favorites (`favorite.service.ts`) — reusing axiosIns so the auth headers
 * and 401 interceptor still apply. The module is taken from the token's audience claim
 * server-side, so nothing here needs to send it.
 */
export const NotificationService = {
  /** Topbar bell feed — newest first, read and unread. */
  my: async (limit = 10): Promise<any> =>
    await axiosIns.get(`/notification/my?limit=${limit}`, {baseURL: ENV.portalGetway}),

  unreadCount: async (): Promise<any> =>
    await axiosIns.get('/notification/unread-count', {baseURL: ENV.portalGetway}),

  /** Paged list for the Notifications page. */
  getList: async (payload: any): Promise<any> =>
    await axiosIns.post('/notification/filter', payload, {baseURL: ENV.portalGetway}),

  markRead: async (payload: {id: string}): Promise<any> =>
    await axiosIns.post('/notification/mark-read', payload, {baseURL: ENV.portalGetway}),

  markAllRead: async (): Promise<any> =>
    await axiosIns.post('/notification/mark-all-read', {}, {baseURL: ENV.portalGetway}),

  dismiss: async (payload: {id: string}): Promise<any> =>
    await axiosIns.delete('/notification/dismiss', {data: payload, baseURL: ENV.portalGetway}),
}
